import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ###### 1 => Framework imports ############
// ###### 2 => React imports #############
import React, { memo } from "react";
import * as Ant from "antd";
export const TitledCard = memo(({ title, ...props }) => {
    return (_jsxs(Ant.Card, { size: "small", ...props, loading: props.loading, children: [_jsx("div", { className: "mar-b-1 fw-bold fs-2", children: title }), !props.loading && props.children] }));
});
